<template>
  <div class="Events">
    <b-container fluid>
    <b-row>
    <b-col md="12">
      <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/events.vue" target="_blank" style="color:black">
        <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
      </a>
      <div class="text-center" id="welcome">
      </div>
      <h2 id="event-heading">Unclassified Events</h2>
      <!--<vue-csv-downloader :data="items" :fields="fields"> Download csv
      </vue-csv-downloader>-->
      <b-button size="sm" @click.stop="refreshOriginalList" class="mr-1">
        Reload Page
      </b-button>
      <b-button size="sm" @click.stop="fetchUnclassifiedByAnybody" class="mr-1">
        Unclassified by anybody
      </b-button>
      <b-button size="sm" @click.stop="fetchMyUnclassifiedEvents" class="mr-1">
        Unclassified by me
      </b-button>
      <b-button size="sm" @click.stop="fetchEventsFurtherClassification" class="mr-1">
        Require Additional Classification
      </b-button>
      <b-button size="sm" @click.stop="fetchMyClassifiedEvents" class="mr-1">
        Classified by me
      </b-button>
      <b-button size="sm" @click.stop="fetchMyRecentlyClassifiedEvents" class="mr-1">
        Recently classified by me
      </b-button>
      <b-row>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Filter" class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Type to Search" />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
        <b-col md="4" class="my-1">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
          <div style="background-color:#f8e2a0">Likely RFI (intensity ML score less than 5)</div>
          <div style="background-color:#a7ddc0">Likely Astrophysical (intensity ML score > 5)</div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
      <!-- Main table element -->
      <b-table show-empty
               :stacked="md"
               :items="items"
               :fields="fields"
               :small="smallTable"
               :current-page="currentPage"
               :per-page="perPage"
               :filter="filter"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :sort-direction="sortDirection"
               @filtered="onFiltered"
      >
        <template v-slot:cell(source)="row">{{row.value.first}} {{row.value.last}}</template>
        <template v-slot:cell(isActive)="row">{{row.value?'Yes :)':'No :('}}</template>
        <template v-slot:cell(actions)="row">
          <b-button size="sm" @click.stop="showSource(row.item, row.index, $event.target)" class="mr-1">
            View Event
          </b-button>
          <b-button size="sm" @click.stop="showRatings(row.item, row.index, $event.target)" class="mr-1">
            Ratings
          </b-button>
          <b-button size="sm" @click.stop="showBandaid(row.item, row.index, $event.target)" class="mr-1">
            Wiki text
          </b-button>
          <b-button size="sm" @click.stop="showQualityFactors(row.item, row.index, $event.target)" class="mr-1">
            Quality Factors
          </b-button>
        </template>
        <template v-slot:cell(row-details)="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li>
            </ul>
          </b-card>
        </template>
      </b-table>
      <!-- Event Viewer Embeded -->
      <div id="eventViewer" style="display:none">
        <div class="float-left">
          <b-button size="lg" variant="secondary" @click.stop="hideSource($event.target)" class="mr-1">
            Hide Event
          </b-button>
        </div>
        <b-button size="lg" variant="danger" @click.stop="classifyAirplane" class="mr-1">
          Airplane/RFI
        </b-button>
        <b-button size="lg" variant="info" @click.stop="userVerification($event.target)" class="mr-1">
          Manual Classification
        </b-button>
        <b-button size="lg" variant="warning" @click.stop="classifyPulsar" class="mr-1">
          Known Pulsar
        </b-button>
        <div class="float-right">
          <b-button size="lg" variant="dark" @click.stop="classifyRepeater" class="mr-1">
            Guaranteed REPEATER
          </b-button>
        </div>
        <div class="float-right">
          <b-button size="lg" variant="success" @click.stop="classifyBest" class="mr-1">
            Guaranteed FRB Candidate
          </b-button>
        </div>
        <div class="float-right">
          <b-button size="lg" variant="info" @click.stop="classifyFaint" class="mr-1">
            Noise/Faint
          </b-button>
        </div>
        <b-embed id="eventPlot" type="iframe" aspect="1by1" src=""></b-embed>
      </div>
      <b-row>
      </b-row>
      <span id="classification_status" style="color:darkolivegreen;font-weight:bold"></span>

      <!-- Bandaid modal-->
      <b-modal size="lg" id="bandaid" title = "#Bandaid" style="text-align:center">
        <div class="bandaid-modal">{{this.bandaidInfo}}</div>
      </b-modal>
      <!-- Display Ratings modal -->
      <b-modal size="lg" id="ratingInfo" @ok="getRatings" :title ="fieldtitle" style="text-align:center">
        <b-table show-empty
               :items="userVerificationItems"
               :fields="userVerificationFields"
               :small="smallTable"
               :dark="dark"
               :fixed="fixed"
        >
        </b-table>
      </b-modal>
      <!-- Display Quality Factors modal -->
      <b-modal size="lg" id="qualityInfo" @ok="getQualityFactors" :title ="fieldtitle" style="text-align:center">
        <b-table show-empty
               :items="qualityFactorItems"
               :fields="qualityFactorFields"
               :small="smallTable"
               :dark="dark"
               :fixed="fixed"
        >
        </b-table>
      </b-modal>
      <!-- User Verification Modal-->
      <b-modal size="lg" id="userVerificationModal" @ok="saveUserVerification" ref="modal">
        <details>
          <summary>Click Me for help with classification</summary>
          <p> Ratings go from 1 (RFI/Airplane)-5 (Astrophysical -- FRB Candidate/Known Source) based on how you rate this event as being astrophysical.</p>
          <p> If your Rating score is 1/2 -- classsify it as RFI.</p>
          <p> If your Rating score is 3/4/5 -- classsify it as Known Source/FRB Candidate depending on what it could be.</p>
          <p> If you classify it as a known source, you have to enter the name of the known source it corresponds to. The button to check for nearby known sources should help with this.</p>
        </details>
        <b-form>
          <b-form-checkbox id="deleteData"
            value="delete"
            unchecked-value="do_not_delete">
            Delete Intensity Data
          </b-form-checkbox>
          <br/>
          <br/>
          <label class="mr-sm-2" for="eventClassificiation"> Classificiation: </label>
          <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                         :value="null"
                         @change.native="updateDeleteToggle"
                         :options="classificationchoices"
                         id="eventClassification">
          </b-form-select>
          <label class="mr-sm-2" for="eventRating"> Rating: </label>
          <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                         :value="null"
                         :options="ratingchoices"
                         id="eventRating">
          </b-form-select>
          <div role="group">
            <label for="knownSource">Known Source Name:</label>
            <b-form-input id="knownSource"
                          v-model.trim="knownsource"
                          type="text"
                          :state="nameState"
                          aria-describedby="inputLiveHelp inputLiveFeedback"
                          placeholder="Enter Known Source name "></b-form-input>
            <b-form-invalid-feedback id="inputLiveFeedback">
              <!-- This will only be shown if the preceeding input has an invalid state -->
              Enter at least 8 letters (eg. B0329+54)
            </b-form-invalid-feedback>
            <b-form-text id="inputLiveHelp">
              <!-- this is a form text block (formerly known as help block) -->
              Known Source Name
            </b-form-text>
          </div>
          <label class="mr-sm-2" for="userComments"> Comments: </label>
          <b-form-textarea id="userComments"
            v-model="comments"
            placeholder="Enter your comments"
            :rows="3"
            :max-rows="6">
          </b-form-textarea>
        </b-form>
      </b-modal>
    </b-container>
  </div>
</template>
<style type="text/css">
/* in the css file or in a style block */
.bandaid-modal {
    white-space: pre-wrap;
}
</style>
<script>
import { AuthVerificationMixin } from './mixins/auth_mixin.js'
// import VuePlotly from '@statnett/vue-plotly'
// import VueCsvDownloader from 'vue-csv-downloader'
var baseUrl = 'https://frb.chimenet.ca/frb-master/'
// baseUrl = 'http://localhost:8001/'
var fields = [
  {key: 'event_id', label: 'Event No', sortable: true, 'class': 'text-center'},
  {key: 'event_type', label: 'Type', sortable: true, 'class': 'text-center'},
  {key: 'datetime', label: 'Datetime (UTC)', sortable: true, 'class': 'text-center'},
  {key: 'dm', label: 'DM', sortable: true, 'class': 'text-center'},
  {key: 'snr', label: 'SNR', sortable: true, 'class': 'text-center'},
  {key: 'ra', label: 'Right Ascension', sortable: true, 'class': 'text-center'},
  {key: 'dec', label: 'Declination', sortable: true, 'class': 'text-center'},
  {key: 'data_status', label: 'Data Available', 'class': 'text-center'},
  {key: 'num_ratings', label: '# User Ratings', sortable: true, 'class': 'text-center'},
  {key: 'max_rating', label: 'Max User Rating', sortable: true, 'class': 'text-center'},
  {key: 'actions', label: 'Actions', 'class': 'text-center'}
]
var userVerificationItems = []
var userVerificationItemsToShow = {}
var userVerificationFields = [
  {key: 'uname', label: 'Name', sortable: false, 'class': 'text-center'},
  {key: 'uclassification', label: 'Classification', sortable: false, 'class': 'text-center'},
  {key: 'urating', label: 'Rating', sortable: false, 'class': 'text-center'},
  {key: 'ucomments', label: 'Comments', sortable: false, 'class': 'text-center'},
  {key: 'udelete', label: 'Delete Data?', sortable: false, 'class': 'text-center'},
  {key: 'uknownsource', label: 'Known Source?', sortable: false, 'class': 'text-center'}
]
var qualityFactorFields = [
  {key: 'qualityFactorField', label: 'Quality Factor', sortable: false, 'class': 'text-center'},
  {key: 'qualityFactorDescription', label: 'Description', sortable: false, 'class': 'text-center'},
  {key: 'qualityFactorValue', label: 'Value', sortable: false, 'class': 'text-center'}
]
var qualityFactorItems = []
var qualityFactorItemsToShow = {}
var selectitems = []
var selectfields = []
var classificationchoices = ['NEW CANDIDATE', 'KNOWN SOURCE', 'REPEATER', 'RFI', 'FAINT']
var ratingchoices = [1, 2, 3, 4, 5]
var previousItem = {}
export default {
  components: {
    // VueCsvDownloader
  },
  mixins: [AuthVerificationMixin],
  data () {
    return {
      baseUrl: baseUrl,
      items: [],
      fields: [],
      bandaidInfo: null,
      // users: [],
      comments: '',
      knownsource: '',
      classificationchoices: ['NEW CANDIDATE', 'KNOWN SOURCE', 'REPEATER', 'RFI', 'FAINT'],
      ratingchoices: [1, 2, 3, 4, 5],
      showfields: [],
      selectitems: [],
      selectfields: [],
      qualityFactorFields: [],
      qualityFactorItems: [],
      qualityFactorItemsToShow: {},
      userVerificationItems: [],
      userVerificationItemsToShow: {},
      userVerificationFields: [],
      fieldtitle: 'User Ratings',
      smallTable: true,
      dark: false,
      fixed: true,
      currentPage: 1,
      perPage: 5,
      // totalRows: items.length,
      pageOptions: [ 5, 10, 15, 50, 100 ],
      sortBy: null,
      plot: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      modalInfo: { title: '', content: '' }
    }
  },
  mounted () {
    this.reloadWindow()
    if (this.user) {
      document.getElementById('welcome').innerHTML = 'Welcome @' + localStorage.username
      var authHeaders = {'Authorization': localStorage.accessToken}
      /* var eventUrl = this.baseUrl + 'v1/events'
      this.$http.get(eventUrl, {headers: authHeaders})
        .then(eventresponse => {
          this.parseEvents(eventresponse.body)
        }, eventeresponse => {
        }) */
      this.getDelayedData(authHeaders)
      // var userUrl = this.baseUrl + 'v1/verification/get-users'
      // this.$http.get(userUrl, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
      //  .then(response => {
      //    this.users = users
      //    this.parseUsers(response.body)
      //  }, response => {
      //  })
    }
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.showfields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    },
    nameState () {
      return this.knownsource.length > 7
    },
    totalRows () {
      return this.items.length
    }
  },
  methods: {
    needcheckbox (value) {
      if (value === '') {
        return false
      }
      return true
    },
    getDelayedData (authHeaders) {
      var myTimerPromise = this.waitForIt(0)
      Promise.all([myTimerPromise]).then(() => {
        this.fetchVerifications(authHeaders)
      })
    },
    fetchVerifications (authHeaders) {
      var url = this.baseUrl + 'v1/verification/get-verifications/UNCLASSIFIED'
      this.$http.get(url, {headers: authHeaders})
        .then(response => {
          this.fields = fields
          this.userVerificationFields = userVerificationFields
          this.userVerificationItems = userVerificationItems
          this.userVerificationItemsToShow = userVerificationItemsToShow
          this.qualityFactorItems = qualityFactorItems
          this.qualityFactorItemsToShow = qualityFactorItemsToShow
          this.qualityFactorFields = qualityFactorFields
          this.showfields = []
          this.selectitems = selectitems
          this.selectfields = selectfields
          this.classificationchoices = classificationchoices
          this.ratingchoices = ratingchoices
          this.parseResponse(response.body)
        }, response => {
        })
    },
    parseEvents (r) {
      for (var i = 0; i < r.length; i++) {
        var value = {}
        value['event_id'] = r[i].id
        value['event_type'] = r[i].event_type
        value['dm'] = r[i].measured_parameters[0].dm
        value['snr'] = r[i].measured_parameters[0].snr
        value['ra'] = r[i].measured_parameters[0].ra
        value['dec'] = r[i].measured_parameters[0].dec
        for (var j = 0; j < this.items.length; j++) {
          if (value['event_id'] === this.items[j]['event_id']) {
            this.items[j]['dm'] = value['dm'].toFixed(1)
            this.items[j]['snr'] = value['snr'].toFixed(1)
            this.items[j]['ra'] = value['ra'].toFixed(1)
            this.items[j]['dec'] = value['dec'].toFixed(1)
            this.items[j]['event_type'] = value['event_type']
            break
          }
        }
      }
    },
    parseResponse (events) {
      this.items = []
      this.userVerificationItemsToShow = {}
      this.qualityFactorItemsToShow = {}
      for (var i = 0; i < events.length; i++) {
        var item = {}
        item['event_id'] = events[i]['id']
        item['datetime'] = events[i]['datetime'].slice(0, 23)
        item['max_rating'] = events[i]['max_rating']
        // item['delta_rating'] = events[i]['delta_rating']
        item['quality_factors'] = events[i]['quality_factors']
        var str = ''
        if (Object.keys(events[i]).includes('data_status')) {
          if (events[i]['data_status']['intensity_data']) {
            str = str + 'Intensity'
          }
          if (events[i]['data_status']['baseband_data']) {
            if (str.length > 1) {
              str = str + ' & '
            }
            str = str + 'Baseband'
          }
        }
        item['data_status'] = str
        item['user_verifications'] = events[i]['user_verification']
        item['num_ratings'] = item['user_verifications'].length - 1
        item['_rowVariant'] = 'success'
        item['variant'] = 'success'
        item['dm'] = events[i]['dm']// null
        item['snr'] = events[i]['snr']// null
        item['ra'] = events[i]['ra']// null
        item['dec'] = events[i]['dec']// null
        item['event_type'] = events[i]['event_type']
        // this.items.push(item)
        this.qualityFactorItemsToShow[item['event_id']] = []
        if (item['quality_factors'] !== undefined) {
          var dictKeys = Object.keys(item['quality_factors'])
          for (var k of dictKeys) {
            var qfItem = {}
            var description = ''
            qfItem['qualityFactorField'] = k
            qfItem['qualityFactorValue'] = item['quality_factors'][k]
            qfItem['qualityFactorDescription'] = description
            if (k === 'l1_grade') {
              description = '0 (bad) - 10 (good): for each beam; Assigned by the L1b sifter. Based on the SNR vs DM curve.'
              qfItem['qualityFactorValue'] = ''
              for (var a = 0; a < item['quality_factors'][k].length; a++) {
                qfItem['qualityFactorValue'] = qfItem['qualityFactorValue'] + item['quality_factors'][k][a]
                if (a < item['quality_factors'][k].length - 1) {
                  qfItem['qualityFactorValue'] = qfItem['qualityFactorValue'] + ', '
                }
              }
            } else if (k === 'l2_grade') {
              description = '0 (bad) - 10 (good); Assigned by the L2 RFI sifter. Based on the multi-beam grouping of events.'
            } else if (k === 'beam_activity') {
              description = '0 (good) - 1024 (bad); Number of beams in which L1 events were triggered at the same time as this event.'
            } else if (k === 'intensityML_grade') {
              description = 'Image Recognition Deep Learning Algorithm (PyTorch): score (0 is bad 10 is good)'
              qfItem['qualityFactorValue'] = item['quality_factors'][k]['event_score']
              if (qfItem['qualityFactorValue'] < 5) {
                item['_rowVariant'] = 'warning'
                item['variant'] = 'warning'
              }
            }
            qfItem['qualityFactorDescription'] = description
            this.qualityFactorItemsToShow[item['event_id']].push(qfItem)
          }
        }
        this.items.push(item)
        this.userVerificationItemsToShow[item['event_id']] = []
        for (var j = 0; j < item['user_verifications'].length; j++) {
          var uvitem = {}
          uvitem['uname'] = item['user_verifications'][j]['id']
          uvitem['uclassification'] = item['user_verifications'][j]['classification']
          uvitem['urating'] = item['user_verifications'][j]['rating']
          uvitem['ucomments'] = item['user_verifications'][j]['comments']
          uvitem['udelete'] = item['user_verifications'][j]['delete']
          uvitem['uknownsource'] = item['user_verifications'][j]['known_source']
          this.userVerificationItemsToShow[item['event_id']].push(uvitem)
        }
      }
      document.getElementById('event-heading').innerHTML = 'Unclassified Events' + ': ' + this.items.length
    },
    parseUsers (input) {
      this.users = []
      for (var i = 0; i < input.length; i++) {
        this.users.push(input[i]['id'])
      }
      this.users.sort()
      this.classificationchoices = ['NEW CANDIDATE', 'KNOWN SOURCE', 'REPEATER', 'RFI', 'FAINT']
      this.ratingchoices = [1, 2, 3, 4, 5]
    },
    showSource (item, index, button) {
      // Fetch source plot
      // this.$root.$emit('bv::show::modal', 'modalsource', button)
      item['_rowVariant'] = 'dark'
      this.activeEvent = item.event_id
      this.activeItem = item
      var x = document.getElementById('eventViewer')
      var plt = document.getElementById('eventPlot')
      plt.src = ''
      if (previousItem['event_id'] === item['event_id']) {
        if (x.style.display === 'none') {
          x.style.display = 'block'
        } else {
          x.style.display = 'none'
        }
        return
      }
      previousItem['_rowVariant'] = previousItem['variant']// 'danger'
      x.style.display = 'block'
      plt.src = 'https://frb.chimenet.ca/chimefrb/astro_events/show_single_event/' + item['event_id'] + '/'
      previousItem = item
    },
    showBandaid (item, index, button) {
      this.bandaidInfo = '|- \n!<next number> \n !' + item.datetime.split(' ')[0].replace('-', '').replace('-', '').slice(2) + '<A/B/C...> \n |' + item.datetime.split(' ')[1] + ' \n |' + item.event_id + ' \n |' + '<I cannot compute the beam nos.>' + ' \n |' + item.snr.toFixed(2) + ' \n |' + item.dm.toFixed(2) + ' \n |' + item.ra.toFixed(2) + ' \n |' + item.dec.toFixed(2) + ' \n |' + '<File info if you uploaded it>' + ' \n |' + localStorage.username + '\n | \n | \n |-'

      this.$root.$emit('bv::show::modal', 'bandaid', button)
    },
    showRatings (item, index, button) {
      this.userVerificationItems = this.userVerificationItemsToShow[item.event_id]
      this.$root.$emit('bv::show::modal', 'ratingInfo', button)
    },
    showQualityFactors (item, index, button) {
      this.qualityFactorItems = this.qualityFactorItemsToShow[item.event_id]
      this.$root.$emit('bv::show::modal', 'qualityInfo', button)
    },
    hideSource () {
      var x = document.getElementById('eventViewer')
      x.style.display = 'none'
    },
    resetModal () {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
    },
    classifyAirplane () {
      var classification = 'RFI'
      var knownSource = ''
      var rating = 1
      var comments = 'airplane'
      var toDelete = '1'
      var toSend = true
      if (!this.user) {
        alert('Please select your userName')
        toSend = false
      }
      if (toSend) {
        this.sendVerification(this.user, classification, toDelete, rating, comments, knownSource, this.activeEvent)
      }
      this.hideSource()
      return false
    },
    classifyBest () {
      var classification = 'NEW CANDIDATE'
      var knownSource = ''
      var rating = 5
      var comments = 'guaranteed frb candidate'
      var toDelete = '0'
      var toSend = true
      if (!this.user) {
        alert('Please select your userName')
        toSend = false
      }
      if (this.activeItem.dm < 100) {
        var confirmation = confirm('The DM is very low!! Are you sure that this is a FRB? You can double check this by clicking on the button: "Ckeck if Known Source". If you need to check again, click on "Cancel"')
        if (!confirmation) {
          toSend = false
        }
      }
      if (toSend) {
        this.sendVerification(this.user, classification, toDelete, rating, comments, knownSource, this.activeEvent)
      }
      this.hideSource()
      return false
    },
    classifyRepeater () {
      var classification = 'KNOWN CANDIDATE'
      var knownSource = ''
      var rating = 5
      var comments = 'guaranteed repeater'
      var toDelete = '0'
      var toSend = true
      if (!this.user) {
        alert('Please select your userName')
        toSend = false
      }
      if (toSend) {
        this.sendVerification(this.user, classification, toDelete, rating, comments, knownSource, this.activeEvent)
      }
      this.hideSource()
      return false
    },
    classifyFaint () {
      var classification = 'FAINT'
      var knownSource = ''
      var rating = 3
      var comments = 'Faint Burst'
      var toDelete = '0'
      var toSend = true
      if (!this.user) {
        alert('Please select your userName')
        toSend = false
      }
      if (toSend) {
        this.sendVerification(this.user, classification, toDelete, rating, comments, knownSource, this.activeEvent)
      }
      this.hideSource()
      return false
    },
    classifyPulsar () {
      var classification = 'KNOWN SOURCE'
      var knownSource = ''
      var rating = 5
      var comments = 'known pulsar'
      var toDelete = '0'
      var toSend = true
      if (!this.user) {
        alert('Please select your userName')
        toSend = false
      }
      if (toSend) {
        this.sendVerification(this.user, classification, toDelete, rating, comments, knownSource, this.activeEvent)
      }
      this.hideSource()
      return false
    },
    saveUserVerification (evt) {
      // evt.preventDefault()
      var classification = document.getElementById('eventClassification').value
      var knownSource = document.getElementById('knownSource').value
      var rating = document.getElementById('eventRating').value
      var comments = document.getElementById('userComments').value
      var toDelete = document.getElementById('deleteData').checked
      var toSend = true
      if (!this.user) {
        alert('Please select your userName')
        toSend = false
      }
      if (!classification) {
        alert('Please select your Classification')
        toSend = false
      }
      if (classification === 'KNOWN SOURCE' && !knownSource) {
        alert('You have classified this event as a known source. Please enter the source name.')
        toSend = false
      }
      if (classification === 'REPEATER') {
        classification = 'KNOWN CANDIDATE'
      }
      if (!rating) {
        alert('Please select your Rating')
        toSend = false
      }
      if (!comments) {
        comments = 'No comments'
      }
      if (toDelete === true) {
        var answer = confirm('Are you sure you want to delete intensity data for this event?')
        if (answer) {
          toDelete = '1'
        } else {
          toDelete = '0'
        }
      }
      if (toSend) {
        this.sendVerification(this.user, classification, toDelete, rating, comments, knownSource, this.activeEvent)
      }
      document.getElementById('deleteData').checked = false
      document.getElementById('userComments').value = null
      this.hideSource()
      return false
    },
    sendVerification (username, classification, toDelete, rating, comments, knownSource, myActiveEvent) {
      var userVerification = {'id': username, 'classification': classification, 'delete': toDelete, 'rating': rating, 'comments': comments, 'known_source': knownSource}
      this.refreshToken()
      var url = this.baseUrl + 'v1/verification/add-user-classification/' + myActiveEvent
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(url, userVerification, {headers: authHeaders})
        .then(response => {
          document.getElementById('classification_status').style.color = 'darkolivegreen'
          document.getElementById('classification_status').innerHTML = 'Successfully Classified Previous Event: ' + myActiveEvent
        }, response => {
          document.getElementById('classification_status').style.color = 'red'
          document.getElementById('classification_status').innerHTML = 'Error classifying event ' + myActiveEvent + ': ' + response.data
        })
    },
    reloadData (url) {
      // Reload the data
      this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(url, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.fields = fields
          this.userVerificationFields = userVerificationFields
          this.userVerificationItems = userVerificationItems
          this.userVerificationItemsToShow = userVerificationItemsToShow
          this.qualityFactorItems = qualityFactorItems
          this.qualityFactorItemsToShow = qualityFactorItemsToShow
          this.qualityFactorFields = qualityFactorFields
          this.showfields = []
          this.selectitems = selectitems
          this.selectfields = selectfields
          this.parseResponse(response.body)
        }, response => {
        })
      if (!url.includes('UNCLASSIFIED')) {
        var eventUrl = this.baseUrl + 'v1/events'
        this.$http.get(eventUrl, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
          .then(eventresponse => {
            this.parseEvents(eventresponse.body)
          }, eventeresponse => {
          })
      }
    },
    fetchMyUnclassifiedEvents () {
      if (!this.user) {
        alert('Please select your userName')
        return false
      }
      var url = this.baseUrl + 'v1/verification/get-verifications-by-me/' + this.user + '/UNCLASSIFIED'
      this.reloadData(url)
    },
    refreshOriginalList () {
      var url = this.baseUrl + 'v1/verification/get-verifications/UNCLASSIFIED'
      this.reloadData(url)
    },
    fetchUnclassifiedByAnybody () {
      if (!this.user) {
        alert('Please select your userName')
        return false
      }
      var url = this.baseUrl + 'v1/verification/get-unclassified-by-anybody'
      this.reloadData(url)
    },
    fetchEventsFurtherClassification () {
      if (!this.user) {
        alert('Please select your userName')
        return false
      }
      var url = this.baseUrl + 'v1/verification/get-verifications-required/' + this.user
      this.reloadData(url)
    },
    fetchMyClassifiedEvents () {
      if (!this.user) {
        alert('Please select your userName')
        return false
      }
      var url = this.baseUrl + 'v1/verification/get-verifications-by-me/' + this.user + '/CLASSIFIED'
      this.reloadData(url)
    },
    fetchMyRecentlyClassifiedEvents () {
      if (!this.user) {
        alert('Please select your userName')
        return false
      }
      var url = this.baseUrl + 'v1/verification/get-recent-verifications-by-user/' + this.user
      this.reloadData(url)
    },
    userVerification () {
      this.$root.$emit('bv::show::modal', 'userVerificationModal')
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    updateDeleteToggle () {
      if (document.getElementById('eventClassification').value === 'RFI') {
        document.getElementById('deleteData').checked = true
      } else {
        document.getElementById('deleteData').checked = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/events.vue